import { Stack, Box, styled } from '@mui/material'
import { Card } from 'components'

const DeliveryBody = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const TitleContainer = styled(Box)`
  width: 100%;
  padding: 16px;
`

const ChartsContainer = styled(Stack)`
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`
const CustomChartContainer = styled(Stack)`
  flex: 2;
  height: 300px;
  min-width: 300px;
  margin-top: 32px;
`
const StatusContainer = styled(Stack)`
  height: 150px;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
`

const TitleSection = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export {
  DeliveryBody,
  ChartsContainer,
  TitleContainer,
  CustomChartContainer,
  StatusContainer,
  TitleSection,
}
